/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.list",
    title: "Email List",
    description: "An inline-styled numbered or dash-bulleted list row for platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "ordered": {
            title: "Ordered",
            type: "boolean",
            description: "When true, renders a numbered list (1. 2. 3.). When false, a dash-bulleted list.",
            required: false,
            default: false
        },
        "items": {
            title: "Items",
            type: "list",
            of: "string",
            description: "The list items. Each item may contain inline formatting (bold/italic/underline/links).",
            required: true
        }
    }
});

var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.list",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    options = options || {};
    var ordered = options.ordered === true || options.ordered === "true";
    var items = Array.isArray(options.items) ? options.items : [];

    var cfg = $.config || {};
    var textColor = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.text) || "#000000";

    // Normalize to strings; drop empty entries.
    var clean = [];
    for (var i = 0; i < items.length; i++) {
        var v = items[i];
        if (v === null || typeof v === "undefined") { continue; }
        v = String(v);
        if (v.trim() === "") { continue; }
        clean.push(v);
    }

    var liStyle = "margin:0 0 6px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:16px;line-height:1.6;color:" + textColor + ";";
    var listInner = "";
    var text = "";

    if (ordered) {
        // Numbered list — <ol> renders the decimals; inline padding keeps markers
        // inside the 480px column and consistent across clients.
        for (var o = 0; o < clean.length; o++) {
            listInner += `<li style="${liStyle}">${clean[o]}</li>`;
            text += (o + 1) + ". " + clean[o] + "\n";
        }
        var olHtml = `<ol style="margin:0;padding:0 0 0 24px;">${listInner}</ol>`;
        var html = `<tr>
  <td style="padding:8px 20px;">
    ${olHtml}
  </td>
</tr>`;
        return { html, text: text.replace(/\n$/, "") };
    }

    // Dash-bulleted list — CSS has no native dash marker, so we suppress the
    // default bullet and prefix each item with an en-dash (renders identically
    // across Gmail / Outlook / Apple Mail).
    for (var u = 0; u < clean.length; u++) {
        listInner += `<li style="${liStyle}">&#8211;&nbsp;${clean[u]}</li>`;
        text += "- " + clean[u] + "\n";
    }
    var ulHtml = `<ul style="list-style:none;margin:0;padding:0;">${listInner}</ul>`;
    var htmlU = `<tr>
  <td style="padding:8px 20px;">
    ${ulHtml}
  </td>
</tr>`;
    return { html: htmlU, text: text.replace(/\n$/, "") };
};
